import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import fullscreenReducer from '../reducers/fullscreen';
import iosReducer from '../reducers/ios';
import charReducer from '../reducers/char';
import wordReducer from '../reducers/word';
import sectionReducer from '../reducers/section';
import thunk from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
    const store = createStore(
        combineReducers({
            fullscreen: fullscreenReducer,
            ios: iosReducer,
            char: charReducer,
            word: wordReducer,
            section: sectionReducer
        }),
        composeEnhancers(applyMiddleware(thunk))
    );

    return store;
};


// WEBPACK FOOTER //
// ./src/store/configureStore.js